












import { namespace } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";

const Auth = namespace("auth");

@Component({})
export default class AuthPanel extends Vue {
  @Auth.State("user")
  private user!: any;

  @Auth.Action("logout")
  logout!: () => Promise<void>;
}
